import { render, staticRenderFns } from "./BundleDemoRoute.vue?vue&type=template&id=d98777ea&scoped=true"
import script from "./BundleDemoRoute.vue?vue&type=script&lang=ts"
export * from "./BundleDemoRoute.vue?vue&type=script&lang=ts"
import style0 from "./BundleDemoRoute.vue?vue&type=style&index=0&id=d98777ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98777ea",
  null
  
)

export default component.exports